import type { IEvent } from "@/core/plugins/Events/Event";
import { DITypes } from "@/core/@types/types";
import { injectable, inject, optional } from "inversify";
import type { AxiosInstance } from "axios";
import { AxiosAdapter } from "@/core/services/AxiosAdapter";
import { type IHttpTokenInterceptor } from "@/core/services/middleware/HttpTokenInterceptor";
import { financasApiBaseUrl } from "@/core/services/protocols";

@injectable()
export default class FinancasApiHttpClient extends AxiosAdapter {
  constructor(
    @inject(DITypes.EVENT) event: IEvent,
    @inject(DITypes.INTERCEPTOR)
    @optional()
    axiosTokenInterceptor?: IHttpTokenInterceptor<AxiosInstance>
  ) {
    super(event, axiosTokenInterceptor);

    this.setup(financasApiBaseUrl, true);
  }
}
